import JobWorkerStatus from "@/models/JobWorkers/JobWorkerStatus";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerStatusInterviewingRequest extends BaseUpdateRequest { 
    jobWorkerId = '';
    status: JobWorkerStatus;
}
